/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AuthAttemptResponseDto = {
  /**
   * User name of the attempter.
   */
  userName: string;
  /**
   * IP address of the attempter.
   */
  ipAddress: string;
  /**
   * Value of the 'User-Agent' header extracted from attempter's HTTP request.
   */
  userAgent?: string;
  /**
   * Attempted authorization type.
   */
  type: AuthAttemptResponseDto.type;
  /**
   * Timestamp (epoch millisecond) when authorization attempt was made.
   */
  timestamp: string;
  /**
   * True when authorization attempt was successful and user was able to proceed, false otherwise.
   */
  successful: boolean;
  /**
   * Value of the 'Country' and 'City' headers extracted from attempter's HTTP request. For example Latvia (Riga).
   */
  location?: string;
};
export namespace AuthAttemptResponseDto {
  /**
   * Attempted authorization type.
   */
  export enum type {
    SIGN_IN = 'SIGN_IN',
    SIGN_IN_CHALLENGE = 'SIGN_IN_CHALLENGE',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD',
    FORGOT_PASSWORD_CONFIRM = 'FORGOT_PASSWORD_CONFIRM',
    DEVICE_ACTIVATION = 'DEVICE_ACTIVATION',
  }
}

